import React from "react";
import { Link, useParams } from "react-router-dom";
import { Button, Divider } from "@mui/material";
import { EditOutlined } from "@mui/icons-material";

import { useGetCollectionDetailQuery } from "store/services/collectionApi";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import CollectionBasicDetail from "./CollectionComponents/CollectionBasicDetail";

import {
  ShipmentFulfillmentDetailContext,
  useShipmentFulfillmentDetailContext,
} from "contexts/ShipmentFulfillmentContext";

import { useAuth } from "hooks";

import CollectionDetailTab from "./CollectionComponents/CollectionDetailTab";

const CollectionDetailScreen = () => {

  const { isDriver, isContractor } = useAuth();

  const { id } = useParams();

  const breadcrumbs = [
    {
      title: "Collections",
      path: isDriver ? "/app/driver/myShipments" : isContractor ? "/app/contractor/myShipments" : "/app/crm/collection/list",
    },
    { title: "Collection Detail" },
  ];
  // RTK Query
  const {
    data: fulfillmentDetail,
    isLoading: loadingFulfillment,
    error,
  } = useGetCollectionDetailQuery(id);
  return (

    <ShipmentFulfillmentDetailContext.Provider
      value={{ fulfillmentDetail, loadingFulfillment }}
    >
      <BreadcrumbLayout
        breadcrumbs={breadcrumbs}
        isBusy={loadingFulfillment}
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error error={error} />

        <BreadcrumbLayout.Paper>
          <CollectionBasicDetail />
          <Divider />
          <CollectionDetailTab/>
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </ShipmentFulfillmentDetailContext.Provider>
  );
};

export default CollectionDetailScreen;

const PageActions = () => {
  const { fulfillmentDetail } = useShipmentFulfillmentDetailContext();
  const { isDriver } = useAuth();
  return (
    <div className="flex items-center gap-4">
      {!isDriver && (
        <Link
          to={`/app/crm/collection/${fulfillmentDetail?._id}/edit`}
        >
          <Button startIcon={<EditOutlined />} variant="contained">
            Edit
          </Button>
        </Link>
      )}
    </div>
  );
};
